var cov_18dm0lsndd = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Slider/index.ts",
      hash = "5dacd3df850bd119e74a3d2fb77299dfc80f29f5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Slider/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 15
        },
        end: {
          line: 5,
          column: 35
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 37
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import Container from './Container';
var Slider = (cov_18dm0lsndd.s[0]++, inputable(Container));
cov_18dm0lsndd.s[1]++;
Slider.displayName = 'ShineoutSlider';
export default Slider;